/* tslint:disable:no-trailing-whitespace import-spacing no-inferrable-types typedef-whitespace whitespace */

import { Injectable  }           from '@angular/core';
import { HttpClient }           from '@angular/common/http';
import { HttpHeaders }           from '@angular/common/http';
import { HttpParams  }           from '@angular/common/http';
import { AuthenticationService } from './authentication.service';

import {
  Blob,
  BlobType
}                                from '../models/blob';
import { User       }            from '../models/user';

@Injectable({
  providedIn: 'root'
})

/**
 *
 * @class UUIDService
 *
 * @brief simple UUID service to help us fetch and work with globally unique idis
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      June 2020
 *
 */
export class UUIDService {

  constructor(
    private http: HttpClient,
    private auth: AuthenticationService
  ) {

  }

  /** fetch any headers we need to send along with our request */
  headers(): HttpHeaders {

    const user: User = this.auth.userOfSession;

    if (!user) {

      /* no user logged in */

      return null;
    }

    return new HttpHeaders().set('Authorization', `Bearer ${user.token}`);
  }

  /** generate a new UUID that only we can use */
  public generate() {

    const headers: HttpHeaders = this.headers();

    if (!headers) {

      return null;
    }

    return this.http.get<string>(`/backend/uuid/generate`, {
      headers
    });
  }


}
